import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react'
import _ from 'lodash'
// import LocationListpop from '../popper';
import { TopicChip } from '../../topicChip';
// import { useSelector, useDispatch } from 'react-redux'
// import { masterDataSelector } from '../../../../store/slices/masterData'

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import LocationListpop from '../../popper'
import {
  Tooltip,
  Card,
  CardContent,
  Icon,
  Typography,
  Box,
  Stack,
  Grid,
  FormControlLabel,
  Checkbox,
  Button,
  FormControl,
  InputLabel,
  OutlinedInput,
  Select,
  ListItemText,
  MenuItem,
  TextField,
  RadioGroup,
  Radio,
  Pagination,
  Menu,
  ToggleButton,
  Divider,
  Link,
  List,
  DialogTitle,
  DialogContent,
  DialogActions,
  Collapse,
  styled,
  useTheme
} from '@mui/material';
import { blue } from '@mui/material/colors';
import { useSelector } from 'react-redux';
import { locationsSelector } from '../../../../../store/slices/location';
import LocationSelector from '../../../navbar/locationSelector';
import SourceFilter from '../../../navbar/sourceFilter';


const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  borderRadius: '20px',
}));
const StyledRadio = styled(Radio)(({ theme }) => ({
  padding: theme.spacing(1),
}));

const emptyClick = () => {

}
const ReviewListFilters = ({ filterObj, reviewsData = [], sortedReviews = [], setSortedReviews, setReviewsPage, openCollapse, filters }) => {
  const theme = useTheme()
  //   const { subTopics } = useSelector(masterDataSelector)
  const [openCollapseArr, setOPenCollapseArr] = useState([])
  //   const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [sentiments, setSentiments] = React.useState([])
  const {subTopics}=useSelector(locationsSelector)
  const sentimentsName = ['Positive', 'Negative'];
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [openTopicFilter, setOpenTopicFilter] = useState(false)

  const [filterParams, setFilterParams] = useState(filterObj)

  const topicRef = useRef()

    const topicFiltersList=useMemo(()=>{
      const tempTopics= _.map(_.filter(_.flatMapDeep(_.cloneDeep(reviewsData), it => it.topics), it => it != null), a => { return ({ ...a, id: (a.sentiment + a.topic) })})
      // debugger
       const tempList= _.map(_.uniqBy(tempTopics,'id'),topic=>{
          const selectedTopic=_.filter(tempTopics,it=>it.topic===topic.topic)
          const totalCount=_.size(selectedTopic)
          const positiveCount=_.size(_.filter(selectedTopic,it=>it.sentiment==='Positive'))
          const negativeCount=_.size(_.filter(selectedTopic,it=>it.sentiment==='Negative'))
          return({...topic,negativeCount,positiveCount,totalCount})
        })
        return tempList
      },[reviewsData])
      // console.log(topicFiltersList)
  //   debugger





    const topicsList = useMemo(() => {
      const tempTopics = _.cloneDeep(subTopics)
      const tempFilterTopics = _.cloneDeep(topicFiltersList)
      const tempReviewsTopics = _.map(tempFilterTopics, topic => {
        // const selectedTopic=_.filter(tempFilterTopics,it=>it.topic===topic.topic)
        // const totalCount=_.size(selectedTopic)

        const categoryObj = _.find(tempTopics, it => it.topic === topic.topic)
        return ({ ...topic, category: categoryObj?.category })
      })


      return _.groupBy(_.orderBy(filterParams.topicFilterType == 0 ?

        _.uniqBy(_.map(_.cloneDeep(tempReviewsTopics), it => ({ category:it.category,topic:it.topic, sentiment: null, id: it.topic, color: blue[600],totalCount:it.totalCount })), 'topic')

        : filterParams.topicFilterType == 1 ?
         _.uniqBy(_.map(_.filter(tempReviewsTopics, it => it.positiveCount>0),t=>({category:t.category,topic:t.topic,sentiment:'Positive',color:theme.palette.success.light,totalCount:t.positiveCount,id:"Positive"+t.topic})),'topic')

          : filterParams.topicFilterType == 2 ?
            _.uniqBy(_.map(_.filter(tempReviewsTopics, it => it.negativeCount>0),t=>({category:t.category,topic:t.topic,sentiment:'Negative',color:theme.palette.error.light,totalCount:t.negativeCount,id:"Negative"+t.topic})),'topic')
            : tempFilterTopics,'totalCount','desc'),'category')


    }, [subTopics, topicFiltersList, filterParams.topicFilterType])



  //==============================================================//
  //=========Functions to set parameter variables values==========//
  const handleCloseTopicFilter = () => {
    setOpenTopicFilter(false)
    handleApplyFilters(true)
  }
  const onChangeTopicFilters = (topic, filters) => {

    if (filterParams.topicFilterType == 0) {
      if (!filterParams.topicFilter?.find(it => it.id === topic.id)) {
        // setTopicFilter(prev=>[...prev,topic])

        setFilterParams(prev => ({ ...prev, topicFilter: [...prev.topicFilter, topic] }))
      }
      else {//setTopicFilter(prev=>_.filter(prev,it=>it.id!==topic.id))
        setFilterParams(prev => ({ ...prev, topicFilter: _.filter(prev.topicFilter, it => it.id !== topic.id) }))
      }

    }
    else if (filterParams.topicFilterType != 0) {
      if (!filterParams.topicFilter?.find(it => it.id === topic.id)) {

        //setTopicFilter(prev=>_.filter([...prev,topic],it=>!(it.topic===topic.topic&&it.sentiment==null)))
        setFilterParams(prev => ({ ...prev, topicFilter: _.filter([...prev.topicFilter, topic], it => !(it.topic === topic.topic && it.sentiment === null)) }))
      }
      else {
        //setTopicFilter(prev=>_.filter(prev,it=>it.id!==topic.id))
        setFilterParams(prev => ({ ...prev, topicFilter: _.filter(prev.topicFilter, it => it.id !== topic.id) }))
      }

    }
    if (filters === true) {
      handleApplyFilters(true)
    }
  }
  const onChangeDateSort = isChecked => {

    setFilterParams(prev => ({ ...prev, dateSort: true, ratingSort: false }))
    setFilterParams(prev => ({ ...prev, sortDir: prev.sortDir === 'desc' ? 'asc' : 'desc' }))

    setSortedReviews(prev => _.orderBy(prev, 'reviewDateTime', filterParams.sortDir === 'desc' ? 'asc' : 'desc'))
  };
  const onChangeRatingSort = isChecked => {


    setFilterParams(prev => ({ ...prev, sortDir: prev.sortDir === 'desc' ? 'asc' : 'desc' }))
    setFilterParams(prev => ({ ...prev, dateSort: false, ratingSort: true }))
    setSortedReviews(prev => _.orderBy(prev, 'rating', filterParams.sortDir === 'desc' ? 'asc' : 'desc'))
  };

    const onChangeCategory = (category) => {
      const categoryTopicList = _.cloneDeep(topicsList[category] ?? [])
      setFilterParams(prev => ({ ...prev, topicFilter: _.concat(prev.topicFilter, categoryTopicList) }))
      //setTopicFilter(prev=>_.uniqBy(_.concat(prev,categoryTopicList),'cId'))

    }
  const toggleTopicCollapse = (category) => {
    if (_.includes(openCollapseArr, category)) {
      setOPenCollapseArr(prev => _.filter(prev, it => it !== category))
    }
    else {
      setOPenCollapseArr(prev => [...prev, category])
    }
  }
  //=======================================================================================//
  //=======================Total reviews size==============================================//
  const countFilteredReviews = (data, filterFunction) => {
    return filters ? data.reduce((count, item) => (filterFunction(item) ? count + 1 : count), 0) : 0;
  };

  const defaultReviewsWithoutTopics = useMemo(() => countFilteredReviews(reviewsData, a => a.topicData === null), [reviewsData, filters]);

  const defaultReviewswithText = useMemo(() => {
    return countFilteredReviews(reviewsData, it => it.reviewText !== null && it.reviewText !== '');
  }, [reviewsData, filters]);

  const defaultReviewswithResponses = useMemo(() => {
    return countFilteredReviews(reviewsData, it => it.responseText);
  }, [reviewsData, filters]);

  const defaultReviewsAwaitingResponse = useMemo(() => {
    const reviewsWithoutResponse = reviewsData?.filter(it => it.responseText === null || it.responseText === '');
    const reviewsAwaitingResponse = reviewsWithoutResponse?.filter(it => it.doNotRespond === true);
    return filters ? reviewsWithoutResponse.length - reviewsAwaitingResponse.length : 0;
  }, [reviewsData, filters]);

  const defaultReviewsPositive = useMemo(() => {
    return countFilteredReviews(reviewsData, it => it.rating >= 4);
  }, [reviewsData, filters]);

  const defaultReviewsNegative = useMemo(() => {
    return countFilteredReviews(reviewsData, it => it.rating <= 3);
  }, [reviewsData, filters]);

  const defaultnoResponseNecessary = useMemo(() => {
    return countFilteredReviews(reviewsData, it => it.doNotRespond === true);
  }, [reviewsData, filters]);

  const defaultnoResponse = useMemo(() => {
    return countFilteredReviews(reviewsData, it => it.responseText === null || it.responseText === '' || !it.responseText);
  }, [reviewsData, filters]);

  const defaultwithoutText = useMemo(() => {
    return countFilteredReviews(reviewsData, it => it.reviewText === null || it.reviewText === '');
  }, [reviewsData, filters]);
  //==========================================================================================================//
  //====================================Filter Reviews Size==================================================//
  const filteredReviewsWithoutTopics = useMemo(() => countFilteredReviews(sortedReviews, a => a.topicData === null), [sortedReviews, filters]);

  const filteredReviewswithText = useMemo(() => {
    return countFilteredReviews(sortedReviews, it => it.reviewText !== null && it.reviewText !== '');
  }, [sortedReviews, filters]);

  const filteredReviewswithResponses = useMemo(() => {
    return countFilteredReviews(sortedReviews, it => it.responseText);
  }, [sortedReviews, filters]);

  const filteredReviewsAwaitingResponse = useMemo(() => {
    const reviewsWithoutResponse = sortedReviews.filter(it => it.responseText === null || it.responseText === '');
    const reviewsAwaitingResponse = reviewsWithoutResponse.filter(it => it.doNotRespond === true);
    return filters ? reviewsWithoutResponse.length - reviewsAwaitingResponse.length : 0;
  }, [sortedReviews, filters]);

  const filteredReviewsPositive = useMemo(() => {
    return countFilteredReviews(sortedReviews, it => it.rating >= 4);
  }, [sortedReviews, filters]);

  const filteredReviewsNegative = useMemo(() => {
    return countFilteredReviews(sortedReviews, it => it.rating <= 3);
  }, [sortedReviews, filters]);

  const filterednoResponseNecessary = useMemo(() => {
    return countFilteredReviews(sortedReviews, it => it.doNotRespond === true);
  }, [sortedReviews, filters]);

  const filterednoResponse = useMemo(() => {
    return countFilteredReviews(sortedReviews, it => it.responseText === null || it.responseText === '' || !it?.responseText);
  }, [sortedReviews, filters]);

  const filteredRating1 = useMemo(() => sortedReviews.filter(it => it.rating === 1).length, [sortedReviews]);
  const filteredRating2 = useMemo(() => sortedReviews.filter(it => it.rating === 2).length, [sortedReviews]);
  const filteredRating3 = useMemo(() => sortedReviews.filter(it => it.rating === 3).length, [sortedReviews]);
  const filteredRating4 = useMemo(() => sortedReviews.filter(it => it.rating === 4).length, [sortedReviews]);
  const filteredRating5 = useMemo(() => sortedReviews.filter(it => it.rating === 5).length, [sortedReviews]);
  const filteredHasIssues = useMemo(
    () => (filters ? _.size(_.filter((sortedReviews), it => it.issueCount > 0)) : 0),
    [sortedReviews]
  );


  const fitleredwithoutText = useMemo(() => {
    return countFilteredReviews(sortedReviews, it => it.reviewText === null || it.reviewText === '');
  }, [sortedReviews, filters]);

  const handleResetFilters = () => {
    setFilterParams(filterObj);
  };
  //   const handleSentiments=(value)=>{
  //       setFilterState(value,true)
  //       setSentiments(prev=>[...prev,value])
  //   }

  const setFilterState = (id, value) => {
    let filter = _.cloneDeep(filterParams);
    if (_.includes(Object.keys(filter), id)) {
      filter[id] = value
    }

    setFilterParams(filter);
    setReviewsPage(1);
  }
  const handleSentimentChange = (event) => {
    const { target: { value } } = event
    setFilterState('sentiment', typeof value === 'string' ? value.split(',') : value)
  }
  const handleRatingChange = (event) => {
    const {
      target: { value },
    } = event;
    setFilterState('starRating', typeof value === 'string' ? value.split(',') : value);
  }
  //===========================================================================================//
  //================Filter Function===========//
  const handleApplyFilters = () => {
    let filteredData = reviewsData;
    //  setReviewTextCheck(false);
    //  setOldResponse(false);
    //  setAwaitResponseCheck(false);
    //  setSentiment([]);
    //  setStarRating([]);
    if (filterParams.withText || filterParams.noText) {

      filteredData = _.filter(
        filteredData,
        it =>
          (filterParams.withText && it.reviewText !== null && it.reviewText !== '') ||
          (filterParams.noText && (it.reviewText === null || it.reviewText === ''))
      );

    }
    if (filterParams.hasResponse || filterParams.noResponse) {
      filteredData = filteredData.filter(
        it =>
          (filterParams.hasResponse && it.responseText !== null && it.responseText !== '') ||
          (filterParams.noResponse && (it.responseText === null || it.responseText === ''))
      );

    }
    if (filterParams.awaitingResponse || filterParams.noResponseNecessary) {
      filteredData = _.filter(
        filteredData,
        it =>
          (filterParams.awaitingResponse &&
            (it.responseText === null || it.responseText === '') &&
            it.doNotRespond == false) ||
          (filterParams.noResponseNecessary && it.doNotRespond === true)
      );
    }
    if (filterParams?.sentiment?.length > 0) {

      filteredData = _.map(filteredData, it => ({ ...it, sentiment: it.rating >= 4 ? 'Positive' : 'Negative' }))

      filteredData = filteredData.filter(item => filterParams?.sentiment.includes(item.sentiment));
    }
    if (filterParams.hasIssues) {
      filteredData = _.filter(filteredData, it => it.issueCount > 0)
    }
    //  if (filterObj?.starRating.length > 0) {
    //     filteredData = filteredData.filter(item =>
    //        filterObj?.starRating.includes(Math.round(item.rating))
    //     );
    //  }
    if (filterParams.positive || filterParams.negative) {
      filteredData = _.filter(
        filteredData,
        it => (filterParams.positive && it.rating >= 4) || (filterParams.negative && it.rating <= 3)
      );
    }
    if (filterParams?.starRating?.length > 0) {
      filteredData = filteredData.filter(item =>
        filterParams?.starRating.includes(Math.round(item.rating))
      );
    }
    if (filterParams.topicFilter?.length > 0 && !filterParams.withoutTopics) {
      filteredData = _.filter(filteredData, review => {
        if (review.topicData) {
          const topic = review.topics?.find(topic => {

            return _.find(filterParams.topicFilter, filter => filter.sentiment ? filter.id === (topic.sentiment + topic.topic) : filter.topic === topic.topic)

          })
          return topic
        }
        return false
      })
    }
    if (filterParams.withoutTopics) {
      filteredData = _.filter(filteredData, it => it.topicData === null)
    }
    if (filterParams.dateSort) {
      filteredData = _.orderBy(filteredData, 'reviewDateTime', filterParams.sortDir);
    }
    if (filterParams.ratingSort) {
      filteredData = _.orderBy(filteredData, 'rating', filterParams.sortDir);
    }
    let tempFilterParams = _.cloneDeep(filterParams);

    setSortedReviews(filteredData)


  }
  //=========================================//
  //=================FIlter Application Condition=================//
  useEffect(() => {

    { handleApplyFilters(true) }

  }, [reviewsData, filterParams])

  //   useEffect(() => setOPenCollapseArr(_.keys(topicsList)), [topicsList])
  //=============================================================//
  const isWithTopic = useMemo(() => filterParams.withoutTopics ? false : true, [filterParams.withoutTopics])
  const ratingsValue = useMemo(() => [{ name: 1, filter: filteredRating1 }, { name: 2, filter: filteredRating2 }, { name: 3, filter: filteredRating3 }, { name: 4, filter: filteredRating4 }, { name: 5, filter: filteredRating5 }], [filteredRating1, filteredRating2, filteredRating3, filteredRating4, filteredRating5])
  return (<>
    <Collapse
      unmountOnExit={false}
      timeout={'auto'}
      in={openCollapse}
      sx={{
        pb: 1,
        mt: -1,
        px: 2,
        mx: -3,
        minHeight: "unset !important",
      }}
    >
      <Grid container alignItems="center" sx={{ m:0,p:0}}>
        <Grid item xs={6} sx={{m:0,p:0}} component={Stack} direction={'row'} alignItems={'center'} spacing={2} gap={2}>
          <Typography variant="subtitle1" >
        <b> Locations</b>
      </Typography>
          <LocationSelector/>
          </Grid>
          <Grid item xs={6} sx={{m:0,p:0}} component={Stack} direction={'row'} alignItems={'center'} spacing={2} gap={2}>
            <Typography variant="subtitle1">
        <b> Sources</b>
      </Typography>
          <SourceFilter/>
          </Grid>
        </Grid>
      <Typography variant="subtitle1" sx={{ ml: 2, mb: -3 }}>
        <b> Filters</b>
      </Typography>
      <Grid container columns={5} spacing={0.5} sx={{ mx: 1, position: 'relative' }}>
        <Grid item xs={1.7} sx={{ mt: 2.2 }}>
          <Grid container columns={1} spacing={0}>
            <Grid item xs={1}>
              <Tooltip
                arrow
                disableInteractive
                title={` ${defaultReviewswithText} Reviews`}
              >
                <FormControlLabel
                  sx={{ userSelect: "none" }}
                  label={`With Text (${filteredReviewswithText})`}
                  value={"date"}
                  control={
                    <StyledCheckbox
                      size="small"
                      checked={filterParams.withText}
                      onChange={(e) =>
                        setFilterState('withText', e.target.checked)
                      }
                    />
                  }
                />
              </Tooltip>
            </Grid>
            <Grid item xs={1}>
              <Tooltip
                arrow
                disableInteractive
                title={` ${defaultnoResponse} Reviews`}
              >
                <FormControlLabel
                  sx={{ userSelect: "none" }}
                  label={`No Response (${filterednoResponse})`}
                  value={"rating"}
                  control={
                    <StyledCheckbox
                      size="small"
                      checked={filterParams.noResponse}
                      onChange={(e) => setFilterState('noResponse', e.target.checked)}
                    />
                  }
                />
              </Tooltip>
            </Grid>
            {/* <Grid item xs={1}>
              <Tooltip
                arrow
                disableInteractive
                title={` ${defaultReviewsAwaitingResponse} Reviews`}
              >
                <FormControlLabel
                  sx={{ userSelect: "none" }}
                  label={`Awaiting Response (${filteredReviewsAwaitingResponse})`}
                  value={"date"}
                  control={
                    <StyledCheckbox
                      size="small"
                      checked={filterParams.awaitingResponse}
                      onChange={(e) =>
                        setFilterState('awaitingResponse', e.target.checked)
                      }
                    />
                  }
                />
              </Tooltip>
            </Grid> */}
            <Grid item xs={1}>
           
                <Tooltip
                  arrow
                  disableInteractive
                  title={` ${filteredHasIssues} Reviews`}
                >
                  <FormControlLabel
                    sx={{ userSelect: "none" }}
                    label={`Has Issues (${filteredHasIssues})`}
                    value={"issueCount"}
                    control={
                      <StyledCheckbox
                        size="small"
                        checked={filterParams.hasIssues}
                        onChange={(e) =>
                          setFilterState('hasIssues', e.target.checked)
                        }
                      />
                    }
                  />
                </Tooltip>
              
              {/* <Tooltip
                arrow
                disableInteractive
                title={` ${defaultReviewsNegative} Reviews`}
              >
                <FormControlLabel
                  sx={{ userSelect: "none" }}
                  label={`Negative (${filteredReviewsNegative})`}
                  value={"date"}
                  control={
                    <StyledCheckbox
                      size="small"
                      checked={filterParams.negative}
                      onChange={(e) =>
                        setFilterState('negative', e.target.checked)
                      }
                    />
                  }
                />
              </Tooltip> */}
              <FormControl size="small" sx={{ minWidth: '150px', mt: 1 }}>
                <InputLabel id="demo-multiple-checkbox-label">
                  Ratings
                </InputLabel>
                <Select
                  size="small"
                  labelId="demo-multiple-checkbox-label-ratings"
                  id="demo-multiple-checkbox-ratings"
                  multiple
                  value={filterParams?.starRating ? filterParams?.starRating : []}
                  onChange={handleRatingChange}
                  input={<OutlinedInput label="Ratings" />}
                  renderValue={(selected) => selected.join(", ")}
                // MenuProps={MenuProps}
                >
                  {ratingsValue.map((name, i) => (
                    <MenuItem key={name.name + i} value={name.name}>
                      <Checkbox checked={filterParams?.starRating?.indexOf(name.name) > -1} />
                      <ListItemText primary={`${name.name} Star (${name.filter})`} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={1.8} sx={{ mt: 2.2 }}>
          <Grid container columns={1} spacing={0}>
            <Grid item xs={1}>
              <Tooltip
                arrow
                disableInteractive
                title={` ${defaultwithoutText} Reviews`}
              >
                <FormControlLabel
                  sx={{ userSelect: "none" }}
                  label={`Without Text (${fitleredwithoutText})`}
                  value={"rating"}
                  control={
                    <StyledCheckbox
                      checked={filterParams.noText}
                      onChange={(e) =>
                        setFilterState('noText', e.target.checked)
                      }
                      size="small"
                    />
                  }
                />
              </Tooltip>
            </Grid>
            <Grid item xs={1}>
              <Tooltip
                arrow
                disableInteractive
                title={` ${defaultReviewswithResponses} Reviews`}
              >
                <FormControlLabel
                  label={`Has Response (${filteredReviewswithResponses})`}
                  value={"date"}
                  control={
                    <StyledCheckbox
                      size="small"
                      checked={filterParams.hasResponse}
                      onChange={(e) =>
                        setFilterState('hasResponse', e.target.checked)
                      }
                    />
                  }
                />
              </Tooltip>
            </Grid>
            {/* <Grid item xs={1}>
              <Tooltip
                arrow
                disableInteractive
                title={` ${defaultnoResponseNecessary} Reviews`}
              >
                <FormControlLabel
                  sx={{ userSelect: "none" }}
                  label={`No Response Necessary (${filterednoResponseNecessary})`}
                  value={"date"}
                  control={
                    <StyledCheckbox
                      size="small"
                      checked={filterParams.noResponseNecessary}
                      onChange={(e) =>
                        setFilterState('noResponseNecessary', e.target.checked)
                      }
                    />
                  }
                />
              </Tooltip>
            </Grid> */}
            <Grid item xs={1}>
              {/* <Tooltip
                arrow
                disableInteractive
                title={` ${defaultReviewsPositive} Reviews`}
              >
                <FormControlLabel
                  sx={{ userSelect: "none" }}
                  label={`Positive (${filteredReviewsPositive})`}
                  value={"date"}
                  control={
                    <StyledCheckbox
                      size="small"
                      checked={filterParams.positive}
                      onChange={(e) =>
                        setFilterState('positive', e.target.checked)
                      }
                    />
                  }
                />
              </Tooltip> */}
              <FormControl size="small" sx={{ minWidth: '150px', mt: 1 }}>
                {/* <InputLabel id="demo-multiple-checkbox-label">
                              Sentiments
                           </InputLabel> */}
                {/* <Select
                              size="small"
                              labelId="demo-multiple-checkbox-label"
                              id="demo-multiple-checkbox"
                              multiple
                              value={filterParams?.sentiment?filterParams?.sentiment:[]}
                              onChange={handleSentimentChange}
                              input={<OutlinedInput label="Sentiments" />}
                              renderValue={(selected) => selected.join(", ")}
                              fullWidth
                           // MenuProps={MenuProps}
                           >
                              {sentimentsName.map((name) => (
                                 <MenuItem key={name} value={name}>
                                    <Checkbox checked={filterParams?.sentiment?.indexOf(name) > -1} />
                                    <ListItemText primary={`${name} (${name==='Positive'?filteredReviewsPositive:filteredReviewsNegative})`} />
                                 </MenuItem>
                              ))}
                           </Select> */}
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={1.5}>
          <Grid container columns={1} spacing={0}>
            <Grid item xs={1}>
              <Typography sx={{ mt: -0.5 }}><b>Sort</b></Typography>
            </Grid>
            <Grid item xs={1}>
              {/* <RadioGroup
               row
               sx={{ ml: 1 }}
               defaultValue={"By Review Date"}
               value={sortOrder}
               onChange={(e) => setSortOrder(e.target.value)}
             >
               <FormControlLabel
               sx={{userSelect:'none'}}
                 label={`Date`}
                 value={"By Review Date"}
                 control={<StyledRadio size="small" />}
               />
               <FormControlLabel
               sx={{userSelect:'none'}}
                 label={`Rating`}
                 value={"By Ratings"}
                 control={<StyledRadio size="small" />}
               />
             </RadioGroup> */}
              <Stack spacing={2} sx={{ mt: 0.5 }}>
                <Stack
                  direction="row"
                  spacing={1}
                  sx={{ cursor: "pointer", mt: 0.6 }}
                  onClick={() => onChangeDateSort(true)}
                  alignItems="center"
                >
                  <Typography
                    color={
                      filterParams.dateSort ? "primary" : ""
                    }
                  >
                    Review Date
                  </Typography>
                  {filterParams.dateSort &&
                    (filterParams.sortDir === "desc" ? (
                      <i className="fi fi-sr-sort-alpha-down" style={{ color: filterParams.dateSort ? theme.palette.primary.main : "" }}></i>

                    ) : (

                      <i className="fi fi-sr-sort-alpha-up" style={{ color: filterParams.dateSort ? theme.palette.primary.main : "" }}
                      ></i>
                    ))}

                </Stack>
                <Stack
                  direction="row"
                  spacing={1}
                  sx={{ cursor: "pointer" }}
                  onClick={() => {
                    onChangeRatingSort(true);

                  }}
                  alignItems="center"
                >
                  <Typography
                    color={filterParams.ratingSort ? "primary" : ""}
                  >
                    Review Rating
                  </Typography>
                  {filterParams.ratingSort &&
                    (filterParams.sortDir === "desc" ? (
                      <i className="fi fi-sr-sort-alpha-down" style={{ color: filterParams.ratingSort ? theme.palette.primary.main : "" }}></i>

                    ) : (

                      <i className="fi fi-sr-sort-alpha-up" style={{ color: filterParams.ratingSort ? theme.palette.primary.main : "" }}
                      ></i>

                    ))}
                </Stack>
                <Box>


                </Box>
              </Stack>
            </Grid>
            {/* <Grid item xs={1}>
                      <Stack sx={{ height: '100%' }} alignItems={'baseline'}>
                      <Button onClick={() => handleApplyFilters(true)}>Apply</Button>
                      </Stack>
                    </Grid> */}
          </Grid>
        </Grid>
        <Button variant='outlined' color={'secondary'} size='small' sx={{ width: '55px !important', mt: 4.7, position: 'absolute', bottom: 4, right: 36 }} component='button' onClick={() => handleResetFilters()}>Reset</Button>
      </Grid>
      {/* {isIRUser && */}

      <Stack direction="row" sx={{ml:2,mr:-0.5,position:'relative',mt:2}}>
              <Typography variant="subtitle1" sx={{mt:'10px'}}>Topics:</Typography>
              <Box

                ref={topicRef}
                onClick={() => setOpenTopicFilter(true)}
                sx={{
                  border: `1px solid ${theme.palette.divider}`,
                  flexGrow: 1,
                  ml: 1,
                  mr: 3,
                  pr: '22px',
                  borderRadius: 1,
                  minHeight: "42px",
                  cursor: filterParams.withoutTopics?'default':'pointer',
                  

                }}
              >
                { openTopicFilter ? <ArrowDropUpIcon sx={{ position: 'absolute', top: '8px', right: '30px' }} /> : <ArrowDropDownIcon sx={{ position: 'absolute', top: '8px', right: '30px' }} /> }
                {filterParams.topicFilter?.length > 0&&filterParams.withoutTopics===false && <Stack sx={{ width: '100%' }} direction='row'
                  m={1}
                  spacing={1}
                  rowGap={1}
                  flexWrap={'wrap'}>{_.map(filterParams.topicFilter, topic => {
                    
                    let totalCount=0
                    if(topic.sentiment!==null)
                    totalCount = _.size(_.filter(sortedReviews, (review) => {
                      if (review.topicData) {
                        const topicList = _.find(review.topics, { sentiment: topic.sentiment, topic: topic.topic });
                        return topicList;
                      }
                      return false;
                    }));
                    else if(topic.sentiment===null){
                      totalCount=_.size( _.filter(sortedReviews, (review) => {
                        if (review.topicData) {
                          const topicList = _.find(review.topics, {  topic: topic.topic });
                          return topicList;
                        }
                        return false;
                      }))
                    }

                  return <TopicChip key={topic.id} label={topic.topic+' ('+totalCount+')'} onDelete={() => onChangeTopicFilters(topic, true)} size='small' sx={{
                    backgroundColor: topic.color,
                    // topic.sentiment === "Positive"
                    //          ? theme.palette.success.light
                    //          :topic.sentiment==="Negative"?theme.palette.error.light:blue[600],
                    color: '#fff'
                  }} />})}
                  <Link alignSelf={'flex-end'} justifySelf={'flex-end'} onClick={() => { setFilterParams(prev => ({ ...prev, topicFilter: [] })) }}>Clear</Link>
                </Stack>}
                
                <LocationListpop
                  sx={{ width: topicRef?.current?.clientWidth?topicRef?.current?.clientWidth:'100%',mt:-1.2,border:`1px solid ${theme.palette.divider}`,borderRadius:'0px 0px 8px 8px'}}
                  disablePortal
                  open={openTopicFilter}
                  anchorRef={topicRef}
                  handleClose={handleCloseTopicFilter}
                 

                >
                  <Stack spacing={2}>
                    <RadioGroup
                      // component={Stack}
                      // spacing={1}
                      sx={{ alignSelf: "flex-start" }}
                      value={filterParams.withoutTopics}
                      onChange={(e) => setFilterParams(prev => ({ ...prev, withoutTopics: e.target.value==='true' }))}
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                    >
                      <Stack direction='row' spacing={0.5} alignItems={'center'}>
                        <Tooltip title={`${_.size(reviewsData)-defaultReviewsWithoutTopics} Reviews`} arrow disableInteractive>
                      <FormControlLabel
                        value={false}
                        control={<StyledRadio />}
                        label={
                          <Typography>Reviews with topic sentiments</Typography>
                         
                        }
                      />
                      </Tooltip>
                       <Stack direction='row' justifyContent={'space-between'} alignItems={'center'} sx={{border:`1px solid ${theme.palette.grey[400]}`,width:'100px',p:0.5,px:1,pr:0.5,borderRadius:1,transition:'all 0.3s ease-in-out',backgroundColor:filterParams.withoutTopics?theme.palette.action.disabledBackground:'inherit',color:filterParams.withoutTopics?theme.palette.text.disabled:''}}  disabled={filterParams.withoutTopics} size='small' onClick={(e)=>filterParams.withoutTopics?emptyClick():handleClick(e)} >
                        {filterParams.topicFilterType===0?"Any":filterParams.topicFilterType===1?'Positive':'Negative'}
                      {!open?<ArrowDropDownIcon/>:<ArrowDropUpIcon/>}
                       </Stack>
                       
                       <Menu
                          slotProps={{
                            backdrop: {
                              sx: { backgroundColor: "transparent" },
                            },
                            paper:{sx:{border:theme=>`1px solid ${theme.palette.divider}`,
                            boxShadow:theme=>theme.shadows[1],}}
                          }}
                       anchorEl={anchorEl}
                       open={open}
                       onClose={handleClose}>
                       
                            <MenuItem  value={0} onClick={e=>{setFilterParams(prev=>({...prev,topicFilterType:e.target.value}));handleClose()}}>Any</MenuItem>
                            <MenuItem value={1} onClick={e=>{setFilterParams(prev=>({...prev,topicFilterType:e.target.value}));handleClose()}}>Positive</MenuItem>
                            <MenuItem value={2} onClick={e=>{setFilterParams(prev=>({...prev,topicFilterType:e.target.value}));handleClose()}}>Negative</MenuItem>
                            </Menu>
                            
                         
                      </Stack>
                      <Tooltip title={`${defaultReviewsWithoutTopics} Reviews`} arrow disableInteractive>
                      <FormControlLabel
                        sx={{ml:1}}
                        value={true}
                        control={<StyledRadio />}
                        label={"Reviews with no topic ("+filteredReviewsWithoutTopics+")"}
                      />
                     </Tooltip>
                    </RadioGroup>
                    <Stack


                      spacing={1}
                      sx={{ maxHeight: "200px", overflowY: "scroll",position:'relative' }}
                    >
                      
                      {_.map(_.keys(topicsList)?.sort(), (category,i) =>
                      { let categoryCount=0
                        _.map(topicsList[category],topic=>categoryCount+=topic.totalCount)
                      return <>
                        <Stack key={category+i} direction={'row'} sapcing={1} alignItems={'center'} >
                          <Box component={'span'} sx={{ cursor: 'pointer' }} onClick={() => toggleTopicCollapse(category)}>{_.includes(openCollapseArr, category) ? <ExpandMoreIcon fontSize='small'/> : <ChevronRightIcon fontSize='small'/>}</Box>
                          
                          <Box>
                            <TopicChip  sx={{ maxWidth: '150px' , transition:'all 0.3s ease-in-out',backgroundColor:isWithTopic?filterParams.topicFilterType===1?theme.palette.success.light:filterParams.topicFilterType===2?theme.palette.error.light:blue[600]:'',color:'#fff'}} label={`${category} (${categoryCount})`} onClick={() => { onChangeCategory(category) }} />
                          </Box>

                        </Stack>
                        {_.includes(openCollapseArr, category) && <Box sx={{ transition: 'all 0.3s ease-in-out' }}>
                          <Stack
                            direction='row'
                            flexWrap={'wrap'}
                            rowGap={1}
                            spacing={1}
                            sx={{ ml: 5 }}
                          >
                            {_.map((topicsList[category]), topic => {
                           const chipLabel=`${topic.topic} (${topic.totalCount})`
                           
                            return <TopicChip
                              key={chipLabel}
                              onClick={() => onChangeTopicFilters(topic)}
                              label={chipLabel}
                              sx={{
                                backgroundColor:isWithTopic?topic.color:'',
                                transition:'all 0.3s ease-in-out',
                                cursor: 'pointer', color: '#fff',
                                opacity: filterParams.topicFilter?.find(it => it.id === topic.id) ? 0.5 : 1
                              }}
                            />})}
                          </Stack></Box>}
                      </>})}
                            {!isWithTopic&&<Box sx={{position:'absolute',top:0,left:0,height:'100%',width:'100%',m:'0px !important',p:0}}></Box>}
                    </Stack>
                  </Stack>
                </LocationListpop>
              </Box>
            </Stack>

      {/* } */}
    </Collapse>
  </>)
}
export default ReviewListFilters